(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shineneon-faq-center"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.sn-faq-center:not([data-faq-ready])');

    sections.forEach((section) => {
      section.setAttribute('data-faq-ready', 'true');

      const form = section.querySelector('[data-faq-search-form]');
      const input = section.querySelector('[data-faq-search-input]');
      const clearButton = section.querySelector('[data-faq-clear]');
      const items = [...section.querySelectorAll('[data-faq-item]')];
      const topicButtons = [...section.querySelectorAll('[data-faq-topic]')];
      const resultTitle = section.querySelector('[data-faq-results-title]');
      const resultDescription = section.querySelector('[data-faq-results-description]');
      const resultCount = section.querySelector('[data-faq-count]');
      const emptyState = section.querySelector('[data-faq-empty]');
      const results = section.querySelector('.sn-faq-center__results');
      const strings = {
        popular: resultTitle.textContent.trim(),
        popularDescription: resultDescription.textContent.trim(),
        allDescription: section.querySelector('.sn-faq-center__section-heading p').textContent.trim(),
        design: section.querySelector('[data-faq-topic="design"] strong').textContent.trim(),
        ordering: section.querySelector('[data-faq-topic="ordering"] strong').textContent.trim(),
        product: section.querySelector('[data-faq-topic="product"] strong').textContent.trim(),
        support: section.querySelector('[data-faq-topic="support"] strong').textContent.trim(),
        resultsFor: section.dataset.resultsFor,
        searchingDescription: section.dataset.searchingDescription,
        answerOne: section.dataset.answerOne,
        answerOther: section.dataset.answerOther,
      };
      let activeTopic = 'all';

      const searchableText = (item) => `${item.textContent} ${item.dataset.keywords || ''}`.toLowerCase();

      const applyFilters = () => {
        const rawQuery = input.value.trim();
        const query = rawQuery.toLowerCase();
        const queryWords = query.split(/\s+/).filter(Boolean);
        let visibleCount = 0;

        items.forEach((item) => {
          const matchesTopic = activeTopic === 'all'
            ? (query ? true : item.dataset.popular === 'true')
            : item.dataset.topic === activeTopic;
          const itemText = searchableText(item);
          const matchesQuery = queryWords.every((word) => itemText.includes(word));
          const visible = matchesTopic && matchesQuery;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        clearButton.hidden = !query;
        resultTitle.textContent = query ? `${strings.resultsFor} “${rawQuery}”` : (activeTopic === 'all' ? strings.popular : strings[activeTopic]);
        resultDescription.textContent = query ? strings.searchingDescription : (activeTopic === 'all' ? strings.popularDescription : strings.allDescription);
        resultCount.textContent = `${visibleCount} ${visibleCount === 1 ? strings.answerOne : strings.answerOther}`;
        emptyState.hidden = visibleCount !== 0;
      };

      const chooseTopic = (topic, shouldScroll = true) => {
        activeTopic = topic;
        topicButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.faqTopic === activeTopic));
        });
        applyFilters();
        if (shouldScroll) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        activeTopic = 'all';
        topicButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.faqTopic === 'all')));
        applyFilters();
        results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      input.addEventListener('input', applyFilters);
      clearButton.addEventListener('click', () => {
        input.value = '';
        input.focus();
        applyFilters();
      });

      topicButtons.forEach((button) => {
        button.addEventListener('click', () => chooseTopic(button.dataset.faqTopic));
      });

      section.querySelectorAll('[data-faq-query]').forEach((button) => {
        button.addEventListener('click', () => {
          input.value = button.dataset.faqQuery;
          activeTopic = 'all';
          topicButtons.forEach((topicButton) => topicButton.setAttribute('aria-pressed', String(topicButton.dataset.faqTopic === 'all')));
          applyFilters();
          results.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      applyFilters();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-brand-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sn-hero-scenes')) {
    customElements.define('sn-hero-scenes', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const panels = [...this.querySelectorAll('[role="tabpanel"]')];
        if (tabs.length < 2) return;
        this.dataset.ready = 'true';
        const select = (tab, focus = false) => {
          tabs.forEach(item => {
            const active = item === tab;
            item.setAttribute('aria-selected', String(active));
            item.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab));
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault();
            select(tabs[next], true);
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-factory-films"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeFactoryFilms = (scope) => {
      const sections = scope.matches?.('[data-sn-factory-films]') ? [scope] : scope.querySelectorAll('[data-sn-factory-films]');
      sections.forEach((section) => {
        if (section.dataset.factoryReady === 'true') return;
        section.dataset.factoryReady = 'true';
        section.querySelectorAll('[data-sn-factory-card]').forEach((card) => {
          const video = card.querySelector('[data-sn-factory-video]');
          const button = card.querySelector('[data-sn-factory-play]');
          if (!video || !button) return;
          const label = button.querySelector('[data-sn-factory-button-label]');
          const status = card.querySelector('.sn-factory-films__status');
          const updatePlayback = (playing) => {
            card.classList.toggle('is-playing', playing);
            const text = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
            label.textContent = text;
            button.setAttribute('aria-label', `${text}: ${button.dataset.clipTitle}`);
            button.setAttribute('aria-pressed', String(playing));
          };
          const pauseOthers = () => {
            document.querySelectorAll('[data-sn-factory-video]').forEach((other) => {
              if (other !== video) other.pause();
            });
          };
          button.addEventListener('click', async () => {
            if (!video.paused) {
              video.pause();
              return;
            }
            pauseOthers();
            status.textContent = '';
            if (!video.getAttribute('src')) video.src = video.dataset.videoSrc;
            try {
              await video.play();
            } catch (error) {
              if (error.name !== 'AbortError') status.textContent = button.dataset.errorLabel;
              updatePlayback(false);
            }
          });
          video.addEventListener('play', () => {
            pauseOthers();
            updatePlayback(true);
          });
          video.addEventListener('playing', () => card.classList.add('is-started'));
          video.addEventListener('pause', () => updatePlayback(false));
          video.addEventListener('ended', () => {
            card.classList.remove('is-started');
            updatePlayback(false);
          });
          video.addEventListener('error', () => {
            status.textContent = button.dataset.errorLabel;
            card.classList.remove('is-started');
            updatePlayback(false);
          });
        });
      });
    };
    initializeFactoryFilms(document);
    document.addEventListener('shopify:section:load', (event) => initializeFactoryFilms(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-sn-factory-video]').forEach((video) => video.pause());
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) document.querySelectorAll('[data-sn-factory-video]').forEach((video) => video.pause());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-project-capabilities"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('sn-project-capabilities')) return;
    customElements.define('sn-project-capabilities', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.tabs = Array.from(this.querySelectorAll('[data-sn-capability-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-sn-capability-panel]'));
        this.picker = this.querySelector('[data-sn-capability-select]');
        this.picker?.addEventListener('change', () => this.select(Number(this.picker.value)), { signal });
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), { signal });
          tab.addEventListener('keydown', (event) => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'ArrowDown') next = (index + 1) % this.tabs.length;
            else if (event.key === 'ArrowUp') next = (index - 1 + this.tabs.length) % this.tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.tabs.length - 1;
            else return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }, { signal });
        });
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail.blockId);
          if (index !== -1) this.select(index);
        }, { signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      select(index) {
        if (this.picker) this.picker.value = String(index);
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (this.panels[tabIndex]) this.panels[tabIndex].hidden = !selected;
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-project-workbench"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sn-project-workbench')) {
    customElements.define('sn-project-workbench', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.querySelectorAll('[data-design-proof]').forEach(proof => {
          proof.querySelectorAll('[data-proof-choice]').forEach(button => {
            button.addEventListener('click', () => {
              proof.querySelectorAll('[data-proof-choice]').forEach(choice => choice.setAttribute('aria-pressed', String(choice === button)));
              proof.querySelectorAll('[data-proof-view]').forEach(view => {
                view.hidden = view.dataset.proofView !== button.dataset.proofChoice;
                if (!view.hidden) view.querySelectorAll('[data-proof-src]').forEach(image => {
                  image.setAttribute('href', image.dataset.proofSrc);
                  delete image.dataset.proofSrc;
                });
              });
            }, { signal });
          });
        });
        this.querySelectorAll('[data-light-demo]').forEach(demo => {
          const player = demo.querySelector('[data-light-player]');
          const play = demo.querySelector('[data-light-play]');
          const modes = [...demo.querySelectorAll('[data-light-mode]')];
          const guides = [...demo.querySelectorAll('[data-light-guide]')];
          const caption = demo.querySelector('[data-light-caption]');
          let selected = modes[0];
          const playLabel = play.querySelector('span:last-child').textContent;
          modes.forEach(mode => mode.addEventListener('click', () => {
            if (selected === mode) return;
            selected = mode;
            player.pause();
            player.removeAttribute('src');
            player.load();
            player.poster = mode.dataset.videoPoster;
            player.setAttribute('aria-label', mode.dataset.videoLabel);
            player.controls = false;
            play.hidden = false;
            play.setAttribute('aria-label', `${playLabel} — ${mode.dataset.videoLabel}`);
            caption.textContent = mode.dataset.videoCaption;
            modes.forEach(button => button.setAttribute('aria-pressed', String(button === mode)));
            guides.forEach(guide => { guide.hidden = guide.dataset.lightGuide !== mode.dataset.lightMode; });
          }, { signal }));
          play.addEventListener('click', () => {
            if (!player.getAttribute('src')) {
              player.src = selected.dataset.videoSrc;
              player.load();
            }
            player.controls = true;
            play.hidden = true;
            player.play().catch(() => { play.hidden = false; });
          }, { signal });
          player.addEventListener('error', () => { play.hidden = false; }, { signal });
        });
        const tabs = [...this.querySelectorAll('[data-workbench-tab]')];
        const panels = [...this.querySelectorAll('[data-workbench-panel]')];
        const options = this.querySelector('.sn-workbench__tabs');
        this.querySelectorAll('[data-workbench-back]').forEach(link => {
          link.addEventListener('click', event => {
            if (!options || !window.matchMedia('(max-width: 749px)').matches) return;
            event.preventDefault();
            const selected = tabs.find(tab => tab.getAttribute('aria-selected') === 'true');
            selected?.focus({ preventScroll: true });
            options.scrollIntoView({
              block: 'start',
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
          }, { signal });
        });
        this.querySelectorAll('video').forEach(video => video.addEventListener('play', () => {
          this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
        }, { signal }));
        const activate = (index, focus = false) => {
          if (!tabs[index]) return;
          const activeId = tabs[index].getAttribute('aria-controls');
          tabs.forEach((tab, tabIndex) => {
            const selected = tabIndex === index;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
          });
          panels.forEach(panel => {
            panel.hidden = panel.id !== activeId;
            if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
            else panel.querySelectorAll('[data-light-poster]').forEach(video => {
              video.poster = video.dataset.lightPoster;
              delete video.dataset.lightPoster;
            });
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activate(index), { signal });
          tab.addEventListener('keydown', event => {
            let nextIndex = index;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') nextIndex = 0;
            else if (event.key === 'End') nextIndex = tabs.length - 1;
            else return;
            event.preventDefault();
            activate(nextIndex, true);
          }, { signal });
        });
        const initialIndex = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
        if (initialIndex >= 0) activate(initialIndex);
        else this.querySelectorAll('[data-light-poster]').forEach(video => {
          if (video.closest('[hidden]')) return;
          video.poster = video.dataset.lightPoster;
          delete video.dataset.lightPoster;
        });
        document.addEventListener('shopify:block:select', event => {
          const index = panels.findIndex(panel => panel.dataset.blockId === event.detail?.blockId);
          if (index >= 0) activate(index);
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sn-studio-capabilities"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sn-project-carousel')) {
    customElements.define('sn-project-carousel', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const track = this.querySelector('[data-sn-project-track]');
        const cards = [...track.children];
        const previous = this.querySelector('[data-sn-project-prev]');
        const next = this.querySelector('[data-sn-project-next]');
        const count = this.querySelector('[data-sn-project-count]');
        if (!cards.length) return;
        let index = 0;
        const position = card => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
        const update = () => {
          index = cards.reduce((nearest, card, i) => Math.abs(position(card) - track.scrollLeft) < Math.abs(position(cards[nearest]) - track.scrollLeft) ? i : nearest, 0);
          previous.disabled = index === 0;
          next.disabled = index === cards.length - 1;
          const label = `${index + 1} / ${cards.length}`;
          if (count.textContent !== label) count.textContent = label;
          track.tabIndex = window.matchMedia('(max-width: 749px)').matches ? 0 : -1;
        };
        const move = target => {
          const card = cards[Math.max(0, Math.min(cards.length - 1, target))];
          track.scrollTo({ left: position(card), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        previous.addEventListener('click', () => move(index - 1), { signal });
        next.addEventListener('click', () => move(index + 1), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track) return;
          const targets = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: cards.length - 1 };
          if (!(event.key in targets)) return;
          event.preventDefault();
          move(targets[event.key]);
        }, { signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(track);
        this.setAttribute('data-ready', '');
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }
    });
  }
  (() => {
    const revealPoster = video => {
      const poster = video.getAttribute('data-sn-demo-poster');
      if (!poster) return;
      video.poster = poster;
      video.removeAttribute('data-sn-demo-poster');
    };
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            revealPoster(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '160px 0px' })
      : null;
    const preparePosters = root => {
      root.querySelectorAll('.sn-studio-advanced video[data-sn-demo-poster]').forEach(video => {
        if (observer) observer.observe(video);
        else revealPoster(video);
      });
    };
    preparePosters(document);
    document.addEventListener('shopify:section:load', event => preparePosters(event.target));
    document.addEventListener('shopify:section:unload', event => {
      if (!observer) return;
      event.target.querySelectorAll('.sn-studio-advanced video[data-sn-demo-poster]').forEach(video => observer.unobserve(video));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
